<template>
  <div>
    <topsearch :searchForm.sync="listParams" @submit="getList" @onClear="onClear" />
    <div class="table">
      <!-- <div class="top">
                <p>
                    <span>已选择</span>
                    <span style="color: #0062FF;">1</span>
                    <span>份合同</span>
                </p>
                <el-button type="primary" plain size="small">下载</el-button>
            </div> -->
      <div class="tableBox" style="padding-bottom: 2px;">
        <div class="title">合同列表</div>
        <etable :list="list" @operate="operate" />
        <hdqPagination
          ref="pagination"
          small
          layout="total,prev, pager, next"
          @change="getList"
          :key="$route.params.dirId"
        />
      </div>
      <dirDialog ref="dirDialog" @success="getList" />
      <insuranceDialog ref="insuranceDialog" @success="getList" />
      <chexiao ref="chexiaoRef" @success="getList" />
      <pdfPopup ref="pdfPopupRef" />
    </div>
  </div>
</template>

<script>
import topsearch from "./topsearch.vue";
import list from "@/views/ElectronicDocuments/mixins/list.js";
const listParams = {
  keyword: "",
  state: "all", //合同状态
  insuranceState: null, //合同保障状态

  empUuid: null,
  initiatedAtFrom: null, //发起合同时间开始
  initiatedAtTo: null, //发起合同时间结束
  finishedAtFrom: null, //完成合同时间开始
  finishedAtTo: null, //完成合同时间结束
};
export default {
  mixins: [list],
  components: {
    topsearch,
  },
  data() {
    return {
      listParams: {
        ...listParams,
      },
    };
  },
  mounted() {
    // this.getList()
  },
  methods: {
    onClear() {
      this.listParams = { ...listParams };
    },
  },
  watch: {
    "$route.params": {
      handler() {
        this.$nextTick(() => {
          const { state, insuranceState } = this.$route.query;
          if (state) {
            this.listParams = { ...this.listParams, state };
          }
          if (insuranceState) {
            this.listParams = { ...this.listParams, insuranceState: +insuranceState };
          }
          console.log("watch", this.$route.params);
          this.getList();
        });
      },
      immediate: true,
    },
    // "$route.params.dirId"(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.listParams.current = 1; // 只重置页码，不调用请求
    //     console.log("dirId changed, reset current to 1");
    //  }
    // },
  },
};
</script>

<style lang="scss" scoped>
.table {
  background: #fff;

  margin-top: 16px;
  border-radius: 6px;
  .top {
    height: 60px;
    display: flex;
    align-items: center;

    p {
      color: #666;
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-right: 20px;
    }
  }
  .tableBox {
    padding: 0 16px;
    .title {
      height: 54px;
      display: flex;
      align-items: center;

      font-weight: 500;
      line-height: normal;
      font-size: 14px;
      color: #262626;
    }
    &::v-deep .hdqPagination{
      justify-content: flex-end;
    }
  }
}
</style>
